import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
// import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import {UserRoleEnum} from "@/enums/userRolesEnum";

export default Vue.component('update-password-card', {
  name: 'UpdatePasswordCard',
  data () {
    return {
      cardExpanded: false,
      currentPasswordErrorMessage: '',
      newPasswordErrorMessage: '',
      confirmNewPasswordErrorMessage: '',
      loadingData: false,
      loadingInitialData: false,
      username: '',
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: ''
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner
  },
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    },
    isFacilityContactUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.FACILITY_CONTACT);
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getUsername()
      }
    },
    getUsername () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/current-user')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data || !response.data.data.username) {
          throw new Error("Error retrieving username.");
        }
        self.username = response.data.data.username;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Retrieving Username',
          text: 'An error occurred getting your username.'
        });
      })
    },
    changePassword (currentPassword: string, newPassword: string, newPasswordConfirmation: string) {
      let self = this
      self.currentPasswordErrorMessage = '';
      self.newPasswordErrorMessage = '';
      self.confirmNewPasswordErrorMessage = '';
      let loadingButtonTimeout = setTimeout(function () {
        self.loadingData = true;
      },500);
      HTTP.put('/api/current-user/change-password', {
        "currentPassword": currentPassword,
        "newPassword": newPassword,
        "newPasswordConfirmation": newPasswordConfirmation,
        accessToken: this.$store.state.user.accessToken
      })
      .then(function (response) {
        clearTimeout(loadingButtonTimeout);
        self.loadingData = false;

        self.currentPassword = '';
        self.newPassword = '';
        self.newPasswordConfirmation = '';

        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Success!',
          text: 'Your password has been successfully changed.'
        });
      })
      .catch(function (error) {
        clearTimeout(loadingButtonTimeout);
        self.loadingData = false;

        self.currentPasswordErrorMessage = getRestParamErrorMessage(error, 'currentPassword');
        self.newPasswordErrorMessage = getRestParamErrorMessage(error, 'newPassword');
        self.confirmNewPasswordErrorMessage = getRestParamErrorMessage(error, 'newPasswordConfirmation');

        if (!self.currentPasswordErrorMessage.length &&
          !self.currentPasswordErrorMessage.length &&
          !self.confirmNewPasswordErrorMessage.length) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Changing Password',
            text: generalError ? generalError : 'An error occurred while changing your password.',
          });
        }

      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/updatePassword/UpdatePasswordCard.ts